module.exports = __webpack_public_path__ + "img/china.52582e4d.svg";